
import { defineComponent } from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import FilterSection from "./FilterSection.vue";

export default defineComponent({
    name: "FilterHolder",
    components: {
        FilterSection
    },
    data(){
      return {
        horizontal: true
      }
    },
    computed: {
        ...mapState(['filter']),
        ...mapGetters({
            filterTitle: 'getFilterTitle',
            cancelLabel: 'getCancelFilterLabel',
            changedSlides: 'getChangedSlides',
            selectedChecks: 'getFilterSelection'
        })
    },
    methods: mapActions({
        clearFilter: 'CLEAR_FILTRATION'
    })
});
